/**
 * Report series from the API always end with the CURRENT, still-accumulating
 * month (see BucketsByMonth in the API: "current month last"). Any derivation
 * that treats that final row as comparable to a full month understates it,
 * which is how a flat metric rendered as a large negative MoM.
 *
 * These helpers drop it, so callers compare and project from complete months only.
 *
 * Total in their argument on purpose. These sit between a network payload and
 * a render, and a page that has not loaded yet, or that was handed a
 * malformed 200, must produce an empty chart rather than a blank screen. They
 * used to assume a defined array and took the partner dashboard down with
 * "Cannot read properties of undefined (reading 'length')". listPayload() in
 * ./payload now guards the same boundary from the other side; both are
 * cheap, and neither alone covers a caller that derives its rows elsewhere.
 */
export function completeMonths<T>(rows: T[] | null | undefined): T[] {
  if (!Array.isArray(rows) || rows.length === 0) {
    return [];
  }

  return rows.slice(0, -1);
}

export function latestCompleteMonth<T>(rows: T[] | null | undefined): T | undefined {
  const complete = completeMonths(rows);

  return complete.length > 0 ? complete[complete.length - 1] : undefined;
}
